import type { ServiceOrganizationRole } from '@common/enums';
import type { ServiceOrganizationSettingRoleDistribution } from '@common/interfaces/api/serviceOrganizationRoleDistributions';

export function getGreatestCommonDivisor(firstNumber: number, secondNumber: number): number {
    if (secondNumber === 0) {
        return firstNumber;
    }

    return getGreatestCommonDivisor(secondNumber, firstNumber % secondNumber);
}

export function convertPercentageToWeight(percentage: number, greatestCommonDivisor: number): number {
    return percentage / greatestCommonDivisor;
}

export function convertWeightToPercentage(weight: number, totalWeight: number): number {
    return (weight / totalWeight) * 100;
}

export function getTotalWeightOfRole(
    role: ServiceOrganizationRole,
    roleDistributions: ServiceOrganizationSettingRoleDistribution[]
): number {
    return roleDistributions.filter((item) => item.role === role).reduce((total, item) => total + item.weight, 0);
}
